/* DYBL 2027 hero behaviour. Reads its data from the #dybl-hero-data JSON block. */
(function(){
  var root = document.querySelector('.dybl-hero-sec');
  var dataEl = document.getElementById('dybl-hero-data');
  if(!root || !dataEl) return;
  /* every Liquid value the hero needs arrives in one JSON block, so this file can be a
     plain cached asset instead of inline script */
  var D = JSON.parse(dataEl.textContent);

  var COVERS = D.covers;

  var TXT = D.txt;

  /* Format computed totals with the pattern of a price Shopify already rendered, so they
     match the server's formatting in every market. Cents are summed as they come and never
     converted: Shopify.currency.rate is not 1 on this store. */
  var pattern = (function(){
    var sample = (root.getAttribute('data-money-sample') || '').replace(/<[^>]*>/g, '').trim();
    var m = sample.match(/[\d][\d.,\s' ]*\d|\d/);
    if(!m) return null;
    var num = m[0], prefix = sample.slice(0, m.index), suffix = sample.slice(m.index + num.length);
    var dm = num.match(/([.,])(\d{2})$/);
    var intPart = dm ? num.slice(0, -3) : num;
    var seps = intPart.replace(/\d/g, '');
    return { prefix:prefix, suffix:suffix, decimals: dm ? 2 : 0, decSep: dm ? dm[1] : '', thouSep: seps ? seps[0] : '' };
  })();
  function money(cents){
    cents = Math.round(cents);
    if(!pattern) return (cents/100).toFixed(2);
    var v = (cents/100).toFixed(pattern.decimals), parts = v.split('.');
    var i = parts[0], d = parts[1] || '';
    if(pattern.thouSep) i = i.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + pattern.thouSep);
    return pattern.prefix + i + (pattern.decimals ? pattern.decSep + d : '') + pattern.suffix;
  }

  /* ---------- add-ons: optional extras ticked in the buy box ---------- */
  var addons = [].slice.call(root.querySelectorAll('[data-addon]'));
  var addonsNote = root.querySelector('[data-addons-note]');
  function addonCents(){
    return addons.filter(function(a){ return a.classList.contains('is-on'); })
      .reduce(function(t,a){ return t + (parseInt(a.getAttribute('data-price'),10) || 0); }, 0);
  }
  function addonItems(){
    return addons.filter(function(a){ return a.classList.contains('is-on'); })
      .map(function(a){ return { id: parseInt(a.getAttribute('data-variant'),10), quantity: 1 }; });
  }
  addons.forEach(function(a){
    a.addEventListener('click', function(){
      var on = a.classList.toggle('is-on');
      a.setAttribute('aria-pressed', on ? 'true' : 'false');
      paintPrice();
    });
  });

  /* ---------- gallery: the shared GGC carousel ---------- */
  var track = root.querySelector('[data-track]');
  var dotsWrap = root.querySelector('[data-dots]');
  var thumbsWrap = root.querySelector('[data-thumbs]');
  var capOut = root.querySelector('[data-cap-out]');
  var i = 0, cells = [], allCells = track ? [].slice.call(track.children) : [];
  var FILTER = root.getAttribute('data-filter-gallery') !== 'false';

  function buildNav(){
    cells = allCells.filter(function(c){ return !c.hidden; });
    dotsWrap.innerHTML = ''; thumbsWrap.innerHTML = '';
    cells.forEach(function(c, n){
      var d = document.createElement('button');
      d.type='button'; d.className='dybl-gal-dot'; d.setAttribute('aria-label','Go to image '+(n+1));
      d.addEventListener('click', function(){ goTo(n); });
      dotsWrap.appendChild(d);

      var t = document.createElement('button');
      t.type='button'; t.className='dybl-thumb';
      var src = c.querySelector('img');
      t.setAttribute('aria-label', (src && src.alt) || ('Image '+(n+1)));
      if(src){ var im=document.createElement('img'); im.src=src.src; im.alt=''; im.loading='lazy'; t.appendChild(im); }
      t.addEventListener('click', function(){ goTo(n); });
      thumbsWrap.appendChild(t);
    });
    /* set both ways round: filtering can take the gallery down to one photo and back up again */
    var few = cells.length < 2 ? 'none' : '';
    root.querySelector('[data-prev]').style.display = few;
    root.querySelector('[data-next]').style.display = few;
    dotsWrap.style.display = few;
    i = 0;
    mark();
  }

  /* Only the selected cover's photos. A photo attached to no variant in Shopify is a photo of
     the inside pages, so every cover keeps it. A cover with no variant yet shows its own
     uploaded artwork instead. If a cover matches nothing at all, show everything rather than
     leave an empty frame. */
  function filterGallery(c){
    if(!FILTER || !allCells.length) return;
    var vid = (c && c.vid) ? String(c.vid) : '';
    var cname = c ? c.name : '';
    var any = false, ownCell = null;
    allCells.forEach(function(cell){
      var own = cell.getAttribute('data-cover-cell');
      var list = (cell.getAttribute('data-variants') || '').split(',').filter(Boolean);
      var show, mine = false;
      if(own){ show = own === cname; mine = show; }
      else if(!list.length) show = true;
      else { show = !!vid && list.indexOf(vid) > -1; mine = show; }
      cell.hidden = !show;
      if(show) any = true;
      if(mine && !ownCell) ownCell = cell;
    });
    if(!any) allCells.forEach(function(cell){ cell.hidden = false; });
    /* this cover's own photo leads, wherever it sits in the product's image order */
    if(ownCell && ownCell !== track.firstElementChild){
      track.insertBefore(ownCell, track.firstElementChild);
      allCells = [].slice.call(track.children);
    }
    buildNav();
  }

  var settle;
  function goTo(n){
    i = Math.max(0, Math.min(cells.length-1, n));
    var target = cells[i].offsetLeft - track.offsetLeft;
    try { track.scrollTo({ left:target, behavior:'smooth' }); } catch(e){ track.scrollLeft = target; }
    /* smooth scrolling gets cancelled when a lazy image lands under it; arriving matters more */
    clearTimeout(settle);
    settle = setTimeout(function(){ if(Math.abs(track.scrollLeft-target) > 4) track.scrollLeft = target; }, 420);
    mark();
    emit('dybl_gallery_slide', { slide: cells[i].getAttribute('data-cap') || ('slide '+(i+1)) });
  }

  function mark(){
    var dots = dotsWrap.children, th = thumbsWrap.children;
    for(var n=0;n<cells.length;n++){
      if(dots[n]) dots[n].setAttribute('aria-current', n===i ? 'true' : 'false');
      if(th[n]){ if(n===i) th[n].setAttribute('aria-current','true'); else th[n].removeAttribute('aria-current'); }
    }
    var p = root.querySelector('[data-prev]'), nx = root.querySelector('[data-next]');
    if(p) p.disabled = i===0;
    if(nx) nx.disabled = i===cells.length-1;
    if(capOut) capOut.textContent = (cells[i] && cells[i].getAttribute('data-cap')) || '';
    /* slide the one line strip only when the active thumb is off screen. scrollIntoView is
       avoided on purpose: it would scroll the page vertically too. */
    var on = thumbsWrap.querySelector('[aria-current="true"]');
    if(on){
      var sr = thumbsWrap.getBoundingClientRect(), orr = on.getBoundingClientRect();
      if(orr.left < sr.left || orr.right > sr.right){
        var to = on.offsetLeft - (thumbsWrap.clientWidth/2) + (on.offsetWidth/2);
        try { thumbsWrap.scrollTo({ left:to, behavior:'smooth' }); } catch(e){ thumbsWrap.scrollLeft = to; }
      }
    }
  }

  if(track){
    buildNav();
    var st;
    track.addEventListener('scroll', function(){
      clearTimeout(st);
      st = setTimeout(function(){
        var w = cells[0] ? cells[0].offsetWidth : 1;
        var n = Math.round(track.scrollLeft / w);
        if(n !== i){ i = n; mark(); }
      }, 90);
    }, { passive:true });
    root.querySelector('[data-prev]').addEventListener('click', function(){ goTo(i-1); });
    root.querySelector('[data-next]').addEventListener('click', function(){ goTo(i+1); });
  }

  /* ---------- selected cover: one source of truth for the whole page ---------- */
  var current = null;

  function byName(n){
    for(var k=0;k<COVERS.length;k++) if(COVERS[k].name === n) return COVERS[k];
    return null;
  }

  function select(name, source){
    var c = byName(name);
    if(!c) return;
    current = c;

    root.querySelectorAll('[data-cover]').forEach(function(b){
      b.setAttribute('aria-pressed', b.getAttribute('data-cover') === name ? 'true' : 'false');
    });
    var nameOut = root.querySelector('[data-cover-name]');
    if(nameOut) nameOut.textContent = c.name;
    var per = root.querySelector('[data-persona]');
    if(per){
      per.innerHTML = '';
      if(c.persona){ var e=document.createElement('em'); e.textContent=c.persona+'.'; per.appendChild(e); per.appendChild(document.createTextNode(' ')); }
      if(c.line) per.appendChild(document.createTextNode(c.line));
    }

    var input = root.querySelector('[data-variant-input]');
    if(input && c.vid){
      input.value = c.vid;
      try { input.dispatchEvent(new Event('change', { bubbles:true })); } catch(e){}
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', String(c.vid).replace(/\D/g,''));
        window.history.replaceState({}, '', u);
      } catch(e){}
    }

    paintTag(c);
    paintPrice();

    /* changing cover reshuffles the gallery and sends it back to the top */
    filterGallery(c);
    if(cells.length) goTo(0);

    document.dispatchEvent(new CustomEvent('dybl:variant-change', {
      bubbles:true, detail:{ name:c.name, variantId:c.vid, price:c.price, priceCents:c.priceCents,
                             tag:c.tag, img:c.img, available:c.available, persona:c.persona,
                             line:c.line, source:source||'swatch' }
    }));
    emit('dybl_cover_select', { cover:c.name, source:source||'swatch' });
  }

  function paintTag(c){
    var el = root.querySelector('[data-cover-tag]');
    if(!el) return;
    if(c.tag){ el.textContent = c.tag; el.hidden = false; } else { el.hidden = true; }
  }

  /* one place decides the shown price and the button, so add-ons and covers cannot disagree */
  function paintPrice(){
    var c = current;
    if(!c) return;
    var extra = addonCents();
    var total = (c.priceCents || 0) + extra;

    var priceOut = root.querySelector('[data-price]');
    if(priceOut && c.priceCents) priceOut.textContent = money(total);
    else if(priceOut && c.price) priceOut.innerHTML = c.price;

    if(addonsNote) addonsNote.textContent = extra > 0 ? ('+' + money(extra)) : (TXT.addonsOptional || 'Optional');

    var atc = root.querySelector('[data-atc]'), lab = root.querySelector('[data-atc-label]');
    if(atc && lab){
      if(!c.vid){ lab.textContent = TXT.atc; atc.disabled = true; }
      else if(c.available){
        lab.innerHTML = TXT.atc + ' &middot; ' + (c.priceCents ? money(total) : (c.price || TXT.fallbackPrice));
        atc.disabled = false;
      }
      else { lab.textContent = TXT.soldOut; atc.disabled = true; }
    }
  }

  root.querySelectorAll('[data-cover]').forEach(function(b){
    b.addEventListener('click', function(){ select(b.getAttribute('data-cover'), 'swatch'); });
  });

  /* other sections ask for a cover; the picker stays the only thing that changes it */
  document.addEventListener('dybl:select-cover', function(e){
    if(e.detail && e.detail.name) select(e.detail.name, e.detail.source || 'other');
  });

  /* ---------- quantity ---------- */
  root.querySelectorAll('[data-qty]').forEach(function(b){
    b.addEventListener('click', function(){
      var inp = root.querySelector('[data-qty-input]');
      var v = parseInt(inp.value, 10) || 1;
      inp.value = Math.max(1, v + parseInt(b.getAttribute('data-qty'), 10));
    });
  });

  /* ---------- add to cart over fetch so the Qikify drawer opens ---------- */
  var form = root.querySelector('form[action*="/cart/add"]');
  if(form) form.addEventListener('submit', function(e){
    e.preventDefault();
    var btn = form.querySelector('[data-atc]'), lab = form.querySelector('[data-atc-label]');
    if(btn.getAttribute('data-busy')) return;
    var prev = lab.innerHTML;
    btn.setAttribute('data-busy','1'); btn.disabled = true; lab.textContent = TXT.adding;
    var restore = function(){ btn.removeAttribute('data-busy'); btn.disabled = false; lab.innerHTML = prev; };
    var items = [{ id: parseInt(root.querySelector('[data-variant-input]').value, 10),
                   quantity: parseInt((root.querySelector('[data-qty-input]')||{}).value, 10) || 1 }]
                 .concat(addonItems());
    fetch('/cart/add.js', { method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: items }) })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        restore();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles:true }));
      })
      .catch(function(){ restore(); window.location.href = '/cart'; });
  });

  document.addEventListener('dybl:add-to-cart', function(){
    if(form){ if(form.requestSubmit) form.requestSubmit(); else form.submit(); }
  });

  /* ---------- analytics, through whatever the theme already uses ---------- */
  function emit(name, payload){
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event:name }, payload)); } catch(e){}
    try { document.dispatchEvent(new CustomEvent('dybl:track', { bubbles:true, detail:{ name:name, payload:payload } })); } catch(e){}
  }
  root.querySelectorAll('[data-quiz-entry]').forEach(function(a){
    a.addEventListener('click', function(){ emit('dybl_quiz_entry_click', { source:a.getAttribute('data-quiz-entry') }); });
  });

  window.DYBL = window.DYBL || {};
  window.DYBL.covers = COVERS;
  window.DYBL.select = select;
  window.DYBL.current = function(){ return current; };
  window.DYBL.emit = emit;

  /* start on the variant the page was loaded with, else the first cover */
  var startName = null;
  for(var k=0;k<COVERS.length;k++){ if(COVERS[k].variantName === D.currentVariant){ startName = COVERS[k].name; break; } }
  if(!startName && COVERS.length) startName = COVERS[0].name;
  if(startName) select(startName, 'load');
})();